import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    showNav: false
  },
  mutations: {
    _storeUser(state, user) {
      state.user = user;
    },
    _purgeUser(state) {
      state.user = {};
    },
    _setNav(state, show) {
      state.showNav = show;
    }
  },
  actions: {
    storeUser({ commit }, user) {
      commit('_storeUser', user);
    },
    purgeUser({ commit }) {
      commit('_purgeUser');
    },
    setNav({ commit }, show) {
      commit('_setNav', show);
    }
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    getShowNav(state) {
      return state.showNav;
    }
  },
  plugins: [createPersistedState()]
});
